import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AccountService } from '../../service/account.service';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-disconnect-patreon',
  imports: [MatDialogModule, MatButtonModule],
  templateUrl: './disconnect-patreon.component.html',
  styleUrl: './disconnect-patreon.component.less'
})
export class DisconnectPatreonComponent {
  accountService = inject(AccountService);
  dialogRef = inject(MatDialogRef<DisconnectPatreonComponent>);
  
  get hasActiveSubscription() {
    if (!this.accountService.account.value) return false;
    if (!this.accountService.account.value.connections.patreon) return false;

    return this.accountService.account.value.connections.patreon.subscriptionTier.id >= 0;
  }

  disconnect() {
    this.accountService.disconnectPatreon().subscribe(() => {
      this.dialogRef.close();
    });
  }
}
